import {
  AccountType,
  PersonaFormData,
  EmpresaFormData,
  UserSkill,
  WorkZone,
  OnboardingStep,
  SkillCategory,
  OnboardingWorkCoverageKind,
} from './types.ts';

export const ONBOARDING_V2_SET_STEP = 'ONBOARDING_V2/SET_STEP';
export const ONBOARDING_V2_SET_ACCOUNT_TYPE = 'ONBOARDING_V2/SET_ACCOUNT_TYPE';
export const ONBOARDING_V2_SET_PERSONA_FORM = 'ONBOARDING_V2/SET_PERSONA_FORM';
export const ONBOARDING_V2_SET_EMPRESA_FORM = 'ONBOARDING_V2/SET_EMPRESA_FORM';
export const ONBOARDING_V2_SET_USER_SKILLS = 'ONBOARDING_V2/SET_USER_SKILLS';
export const ONBOARDING_V2_ADD_SKILL = 'ONBOARDING_V2/ADD_SKILL';
export const ONBOARDING_V2_REMOVE_SKILL = 'ONBOARDING_V2/REMOVE_SKILL';
export const ONBOARDING_V2_SET_WORK_ZONES = 'ONBOARDING_V2/SET_WORK_ZONES';
export const ONBOARDING_V2_SET_ALL_COUNTRY = 'ONBOARDING_V2/SET_ALL_COUNTRY';
export const ONBOARDING_V2_SET_WORK_COVERAGE_KIND = 'ONBOARDING_V2/SET_WORK_COVERAGE_KIND';
export const ONBOARDING_V2_SET_INFLUENCE_MAP = 'ONBOARDING_V2/SET_INFLUENCE_MAP';
export const ONBOARDING_V2_SET_USER_IMAGE = 'ONBOARDING_V2/SET_USER_IMAGE';
export const ONBOARDING_V2_SET_FROM_SKIP = 'ONBOARDING_V2/SET_FROM_SKIP';

export const ONBOARDING_V2_GET_SKILLS_START = 'ONBOARDING_V2/GET_SKILLS_START';
export const ONBOARDING_V2_GET_SKILLS_SUCCESS = 'ONBOARDING_V2/GET_SKILLS_SUCCESS';
export const ONBOARDING_V2_GET_SKILLS_FAIL = 'ONBOARDING_V2/GET_SKILLS_FAIL';

export const ONBOARDING_V2_SET_SKILL_CATEGORIES = 'ONBOARDING_V2/SET_SKILL_CATEGORIES';
export const ONBOARDING_V2_SET_SELECTED_CATEGORY_FILTER = 'ONBOARDING_V2/SET_SELECTED_CATEGORY_FILTER';
export const ONBOARDING_V2_SET_PREFERRED_PROFILE_CATEGORIES = 'ONBOARDING_V2/SET_PREFERRED_PROFILE_CATEGORIES';

export const ONBOARDING_V2_GET_CITIES_START = 'ONBOARDING_V2/GET_CITIES_START';
export const ONBOARDING_V2_GET_CITIES_SUCCESS = 'ONBOARDING_V2/GET_CITIES_SUCCESS';
export const ONBOARDING_V2_GET_CITIES_FAIL = 'ONBOARDING_V2/GET_CITIES_FAIL';

export const ONBOARDING_V2_UPDATE_PROFILE_START = 'ONBOARDING_V2/UPDATE_PROFILE_START';
export const ONBOARDING_V2_UPDATE_PROFILE_SUCCESS = 'ONBOARDING_V2/UPDATE_PROFILE_SUCCESS';
export const ONBOARDING_V2_UPDATE_PROFILE_FAIL = 'ONBOARDING_V2/UPDATE_PROFILE_FAIL';

export const ONBOARDING_V2_RESET = 'ONBOARDING_V2/RESET';

export const setStep = (step: OnboardingStep) => ({
  type: ONBOARDING_V2_SET_STEP,
  payload: step,
});

export const setAccountType = (accountType: AccountType) => ({
  type: ONBOARDING_V2_SET_ACCOUNT_TYPE,
  payload: accountType,
});

export const setPersonaForm = (formData: PersonaFormData) => ({
  type: ONBOARDING_V2_SET_PERSONA_FORM,
  payload: formData,
});

export const setEmpresaForm = (formData: EmpresaFormData) => ({
  type: ONBOARDING_V2_SET_EMPRESA_FORM,
  payload: formData,
});

export const setUserSkills = (skills: UserSkill[]) => ({
  type: ONBOARDING_V2_SET_USER_SKILLS,
  payload: skills,
});

export const addSkill = (skill: UserSkill) => ({
  type: ONBOARDING_V2_ADD_SKILL,
  payload: skill,
});

export const removeSkill = (skillId: number) => ({
  type: ONBOARDING_V2_REMOVE_SKILL,
  payload: skillId,
});

export const setWorkZones = (zones: WorkZone[]) => ({
  type: ONBOARDING_V2_SET_WORK_ZONES,
  payload: zones,
});

export const setAllCountry = (allCountry: boolean) => ({
  type: ONBOARDING_V2_SET_ALL_COUNTRY,
  payload: allCountry,
});

export const setWorkCoverageKind = (kind: OnboardingWorkCoverageKind) => ({
  type: ONBOARDING_V2_SET_WORK_COVERAGE_KIND,
  payload: kind,
});

export const setInfluenceMap = (payload: {
  lat?: number | null;
  lng?: number | null;
  radiusKm?: number;
  placeLabel?: string | null;
}) => ({
  type: ONBOARDING_V2_SET_INFLUENCE_MAP,
  payload,
});

export const setUserImage = (image: string | null) => ({
  type: ONBOARDING_V2_SET_USER_IMAGE,
  payload: image,
});

export const setFromSkip = (isFromSkip: boolean) => ({
  type: ONBOARDING_V2_SET_FROM_SKIP,
  payload: isFromSkip,
});

export const resetOnboarding = () => ({
  type: ONBOARDING_V2_RESET,
});

export const setSkillCategories = (categories: SkillCategory[]) => ({
  type: ONBOARDING_V2_SET_SKILL_CATEGORIES,
  payload: categories,
});

export const setSelectedCategoryFilter = (categoryId: number | null) => ({
  type: ONBOARDING_V2_SET_SELECTED_CATEGORY_FILTER,
  payload: categoryId,
});

export const setPreferredProfileCategories = (categoryIds: number[]) => ({
  type: ONBOARDING_V2_SET_PREFERRED_PROFILE_CATEGORIES,
  payload: categoryIds,
});
